import React, {useEffect, useState} from 'react';
import apiRequests from "../../../Component/axios/config/config";
import Loading from "../../../Component/Loading/Loading";
import {Link} from "react-router-dom";
import noImage from "../../../font & image/image/noImages.png";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";
import {X} from "lucide-react";
import NavBar from "../../../Component/NavBar/NavBar";
import {AiFillProduct} from "react-icons/ai";


export default function AddToOffers() {

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [offerInputs, setOfferInputs] = useState({
        startTime: "",
        expiredTime: "",
        discount: 0
    });
    const [products, setProducts] = useState([]);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");

    const [loading, setLoading] = useState(true);
    const [loadingAddOffer, setLoadingAddOffer] = useState({status: false, id: null});

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchProducts(currentPage);
    }, [currentPage, searchQuery]);

    const fetchProducts = (page) => {

        setLoading(true);
        apiRequests.get(`/api/product/get-all-admin`, {
            params: {
                page: page,
                limit: 10,
                search: searchQuery,
            }
        })
            .then((response) => {
                setProducts(response.data.data.docs);
                setTotalPages(response.data.data.totalPages);
            })
            .catch(() => {
                console.error("Failed to fetch products");
            })
            .finally(() => setLoading(false));
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const toISO = (localDateTime) => {
        if (!localDateTime) return null;
        return new Date(localDateTime).toISOString();
    };

    const handleAddToSpecialOffer = (productId) => {
        setLoadingAddOffer({status: true, id: productId});

        const payload = {
            productId,
            startTime: toISO(offerInputs.startTime),
            expiredtime: toISO(offerInputs.expiredTime),
            discount: Number(offerInputs.discount)
        };

        apiRequests.post("/api/offers/v1/add", payload)
            .then(() => {
                toast.success("Offer added successfully!");
                setSelectedProduct(null);
                fetchProducts(currentPage);
            })
            .catch((err) => {
                if (err.status === 401 || err.status === 403) {
                    navigate("/login");
                }
                toast.error("Failed to add offer");
            })
            .finally(() => {
                setLoadingAddOffer({status: false, id: null});
            });
    };

    return (
        <div className="p-6">

            <div className="flex justify-between items-center mb-8">
                <h1 className="text-2xl font-bold">Add To Special offers</h1>
                <button onClick={() => navigate(-1)} className="text-gray-500 hover:text-gray-700">
                    <X size={24}/>
                </button>
            </div>

            <NavBar
                item={[
                    {
                        icon: <AiFillProduct style={{fontSize: "22px"}}/>,
                        title: "All Products",
                    },
                ]}

                onSearch={(value) => {
                    setSearchQuery(value);
                    setCurrentPage(1);
                }}
            />

            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead className="bg-gradient-to-r from-green-400 to-blue-500 text-white">
                        <tr>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Image</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Name</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap md:hidden">Category</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap md:hidden">Price</th>
                            <th className="px-6 py-3 text-center text-sm font-medium  text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                        {loading ? (
                            <tr>
                                <td colSpan="5" className="px-6 py-4 text-center">
                                    <Loading/>
                                </td>
                            </tr>
                        ) : products.length > 0 ? (
                            products.map((product) => {
                                    return (
                                        <tr key={product._id} className="hover:bg-gray-100 transition duration-200">
                                            <td className="px-6 py-4 text-nowrap">
                                                <img
                                                    src={product.images ? `https://api.goalafarin.com/${product.images[0]?.path}` : noImage}
                                                    alt={product.name?.en}
                                                    className="w-16 h-16 object-cover rounded-lg"
                                                />
                                            </td>
                                            <td className="px-6 py-4 text-gray-800 font-medium text-nowrap">
                                                <Link
                                                    to={`/product/${product._id}`}> {product.name?.en}

                                                </Link>
                                            </td>
                                            <td className="px-6 py-4 text-gray-600 text-nowrap md:hidden">{product.category?.name}</td>
                                            <td className="px-6 py-4 text-gray-800 font-semibold text-nowrap md:hidden">{product.price} $</td>
                                            <td className="px-6 py-4 text-center space-x-4 text-nowrap">
                                                {loadingAddOffer.id === product._id ? (
                                                    <Loading/>
                                                ) : (
                                                    <button
                                                        className="text-green-600 hover:text-green-800 font-medium"
                                                        onClick={() => {
                                                            setSelectedProduct(product);
                                                            setOfferInputs({startTime: "", expiredTime: "", discount: 0});
                                                        }}
                                                    >
                                                        Add to Special Offers
                                                    </button>

                                                )}
                                            </td>
                                        </tr>
                                    )
                                }
                            )
                        ) : (
                            <tr>
                                <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                                    No products found
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>

                    <div className="flex justify-center items-center mt-6 space-x-2">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                            className={`px-3 py-1 rounded-md border ${
                                currentPage === 1
                                    ? "text-gray-400 border-gray-200"
                                    : "text-blue-600 border-blue-400 hover:bg-blue-100"
                            }`}
                        >
                            Prev
                        </button>

                        <span className="px-4">
                            Page {currentPage} of {totalPages}
                        </span>

                        <button
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(currentPage + 1)}
                            className={`px-3 py-1 rounded-md border ${
                                currentPage === totalPages
                                    ? "text-gray-400 border-gray-200"
                                    : "text-blue-600 border-blue-400 hover:bg-blue-100"
                            }`}
                        >
                            Next
                        </button>
                    </div>

                </div>
            </div>
            {selectedProduct && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                        <h2 className="text-xl font-bold mb-4">
                            Add Offer for: {selectedProduct.name?.en}
                        </h2>

                        <div className="space-y-4">

                            <div>
                                <label className="text-sm font-medium">Start Time</label>
                                <input
                                    type="datetime-local"
                                    className="w-full mt-1 px-3 py-2 border rounded-md"
                                    value={offerInputs.startTime}
                                    onChange={(e) =>
                                        setOfferInputs({...offerInputs, startTime: e.target.value})
                                    }
                                />
                            </div>

                            <div>
                                <label className="text-sm font-medium">Expired Time</label>
                                <input
                                    type="datetime-local"
                                    className="w-full mt-1 px-3 py-2 border rounded-md"
                                    value={offerInputs.expiredTime}
                                    onChange={(e) =>
                                        setOfferInputs({...offerInputs, expiredTime: e.target.value})
                                    }
                                />
                            </div>

                            <div>
                                <label className="text-sm font-medium">Discount (%)</label>
                                <input
                                    type="number"
                                    className="w-full mt-1 px-3 py-2 border rounded-md"
                                    value={offerInputs.discount}
                                    onChange={(e) =>
                                        setOfferInputs({...offerInputs, discount: e.target.value})
                                    }
                                />
                            </div>
                        </div>

                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                className="px-4 py-2 bg-gray-300 rounded-md"
                                onClick={() => setSelectedProduct(null)}
                            >
                                Cancel
                            </button>

                            <button
                                className="px-4 py-2 bg-green-600 text-white rounded-md"
                                onClick={() => handleAddToSpecialOffer(selectedProduct._id)}
                            >
                                {loadingAddOffer.status ? <Loading/> :
                                    "Save Offer"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}